import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CTA = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-gradient-cta relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `radial-gradient(circle at 15% 50%, rgba(255,255,255,0.15) 0%, transparent 45%),
                            radial-gradient(circle at 90% 30%, rgba(9,7,15,0.6) 0%, transparent 50%)`,
        }}
      />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-block bg-dark/25 border border-white/20 rounded-full px-4 py-1.5 text-white text-sm font-semibold mb-6 backdrop-blur-sm">
          {t.cta.badge}
        </span>

        <h2 className="text-4xl lg:text-6xl font-extrabold text-white font-heading leading-[1.1] mb-6">
          {t.cta.title}{' '}
          <span className="text-white/95 block sm:inline">{t.cta.titleSub}</span>
        </h2>

        <p className="text-xl text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">{t.cta.body}</p>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-10">
          {t.cta.perks.map((perk) => (
            <div key={perk} className="flex items-center gap-2 text-white/90 text-sm">
              <span className="w-5 h-5 rounded-full bg-dark/40 border border-white/30 flex items-center justify-center shrink-0">
                <Check className="w-3 h-3 text-white" strokeWidth={3} />
              </span>
              <span>{perk}</span>
            </div>
          ))}
        </div>

        <a
          href="/s"
          className="inline-flex items-center gap-3 bg-dark text-primary-light hover:bg-card-dark px-10 py-5 rounded-xl font-extrabold text-xl transition-all shadow-2xl hover:-translate-y-1 border border-white/10"
        >
          {t.cta.button}
          <ArrowRight className="w-6 h-6" />
        </a>

        <div className="mt-8 space-y-2">
          <p className="text-white font-semibold text-sm">{t.cta.priceLine}</p>
          <p className="text-white/80 text-sm">{t.cta.helpLine}</p>
        </div>

        <div className="mt-8 max-w-2xl mx-auto bg-dark/35 rounded-xl p-5 border border-white/10 backdrop-blur-sm">
          <p className="text-white/70 text-xs leading-relaxed text-left">{t.cta.legalBox}</p>
        </div>
      </div>
    </section>
  );
};

export default CTA;
